/* AvéliQ — horizontal-overflow finder.
   Self-gating: does nothing unless the URL carries ?aqdebug=1
   Usage on a phone (no console available): open
     https://your-store/?aqdebug=1
   and a panel lists every element wider than the viewport, worst first.
   Safe to leave in place; remove the script tag before launch if preferred. */
(function () {
  'use strict';
  if (!/[?&]aqdebug=1/.test(window.location.search)) return;

  function run() {
    var vw = document.documentElement.clientWidth;
    var offenders = [];

    document.querySelectorAll('body *').forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.width === 0 && r.height === 0) return;
      var overflowRight = Math.round(r.right - vw);
      var overflowLeft = Math.round(-r.left);
      var worst = Math.max(overflowRight, overflowLeft);
      if (worst < 2) return;

      /* only report the outermost offender in a chain — a wide parent makes
         every child look wide too, which buries the actual cause */
      offenders.push({ el: el, over: worst, right: overflowRight, left: overflowLeft, width: Math.round(r.width) });
    });

    offenders = offenders.filter(function (o) {
      return !offenders.some(function (p) {
        return p !== o && p.el.contains(o.el) && p.over >= o.over - 1;
      });
    });

    offenders.sort(function (a, b) { return b.over - a.over; });

    var describe = function (el) {
      var s = el.tagName.toLowerCase();
      if (el.id) s += '#' + el.id;
      if (el.className && typeof el.className === 'string') {
        s += '.' + el.className.trim().split(/\s+/).slice(0, 3).join('.');
      }
      return s;
    };

    var panel = document.createElement('div');
    panel.setAttribute('style', [
      'position:fixed', 'left:0', 'right:0', 'bottom:0', 'z-index:99999',
      'max-height:52vh', 'overflow:auto', 'background:#1E150D', 'color:#F2EEE8',
      'font:12px/1.5 ui-monospace,Menlo,monospace', 'padding:12px 14px',
      'box-shadow:0 -8px 30px rgba(0,0,0,.4)'
    ].join(';'));

    var html = '<div style="display:flex;justify-content:space-between;align-items:center;gap:10px">' +
      '<b>AVELIQ overflow check</b>' +
      '<button id="aq-dbg-x" style="background:none;border:1px solid #F2EEE8;color:#F2EEE8;border-radius:6px;padding:2px 9px">close</button>' +
      '</div>' +
      '<div style="opacity:.7;margin:6px 0 10px">viewport ' + vw + 'px · scrollWidth ' +
      document.documentElement.scrollWidth + 'px</div>';

    if (!offenders.length) {
      html += '<div>No element exceeds the viewport. The gap is not caused by content width.</div>';
    } else {
      html += offenders.slice(0, 12).map(function (o, i) {
        var side = o.right >= o.left ? 'right +' + o.right : 'left +' + o.left;
        return (i + 1) + '. <b>' + describe(o.el) + '</b><br>' +
          '&nbsp;&nbsp;width ' + o.width + 'px · over ' + side + 'px';
      }).join('<br><br>');
    }

    panel.innerHTML = html;
    document.body.appendChild(panel);
    var closeBtn = document.getElementById('aq-dbg-x');
    if (closeBtn) closeBtn.addEventListener('click', function () { panel.remove(); });

    offenders.slice(0, 5).forEach(function (o) {
      o.el.style.outline = '2px solid #ff3b30';
      o.el.style.outlineOffset = '-2px';
    });
  }

  /* wait for layout + web fonts to settle, and re-check after rotation */
  window.addEventListener('load', function () { setTimeout(run, 600); });
})();
